import React from "react";
import YoutubeEmbed from "../components/navBar/YoutubeEmbed";
import zainabPic from "./pictures/zaino.png";
import muneebPic from "./pictures/munneb.jpg";
import muhammadpic from "./pictures/muhammad.jpg";
import HBD22_1 from "./pictures/HBD22/HBD22_1.jpeg";
import HBD22_2 from "./pictures/HBD22/HBD22_2.jpg";
import HBD22_3 from "./pictures/HBD22/HBD22_3.jpg";
import HBD22_4 from "./pictures/HBD22/HBD22_4.jpg";
import HBD22_5 from "./pictures/HBD22/HBD22_5.jpeg";
import HBD22_6 from "./pictures/HBD22/HBD22_6.jpeg";
import HBD22_7 from "./pictures/HBD22/HBD22_7.jpeg";
import cutoSurprise from "./pictures/22Feb2024/getTogather.jpg";
import SecretMsging from "./SecretMsging";
import OldMsg from "./OldMsg";
import RestorePage from "./RestorePage";
import FavMsg from "./FavMsg";
import ZainoLive from "./ZainoLive";
import MuaazLive from "./MuaazLive";
import DeleteChat from "./DeleteChat";
function LocationPage({ cond }) {
  const zainab = {
    url: "KT7F15T9VBI",
    picture: zainabPic,
    text: "Thank You For Everything , I Cant't really explain that how much I am happy that I have a friend like you Who cares about me and my well being, I know that I am kinda stupid and Dumb dumb for all the stupid things I say and Do ,So I am really thank ful that you Put up with my shit and still are friend with me , In these holidays I didnt got bored thanks to you and really had Good and moment filled time,So I am really ThankFul for that. Any ways , O shit muja yaad aya , Thanks for that email , usa ma yaha neache he laga raha hon for a reminder",
  };
  const muneeb = {
    url: "af4ITJ6FrfA",
    picture: muneebPic,
    text: "Thank you for Everything,  For standing beside me in front of everyone ,for helping me when I needed you the most and for making my uni time awesome as hell, Really thankful for all the Tareef you do of my projects really made my eyes wet lol, Really thank ful for sharing your parts of life with me weather personal or dosra, You are one of those People I never want to lose in life as a friend so I am really belive that we will be good friends like we are for as much long time as possible, May allah keep you and your family healthy and Well.",
  };
  const Muhammad = {
    url: "uMeR2W19wT0",
    picture: muhammadpic,
    text: "Thank you for Everything,  For standing beside me in front of everyone ,for helping me when I needed you the most and for making my uni time awesome as hell, Really You are the defination of brother of anyother mother lol, Really thank ful for sharing your parts of life with me weather personal or dosra, You are one of those People I never want to lose in life as a friend so I am really belive that we will be good friends like we are for as much long time as possible, May allah keep you and your family healthy and Well.",
  };
  const HBD22 = {
    url: "yeWtwEq1G8U",
    picture: [HBD22_1, HBD22_2, HBD22_3, HBD22_4, HBD22_5, HBD22_6, HBD22_7],
    text: "Happy birth day mari jan , Hopefully you are having a great and wonderful day mari jan ❤️️, i had decided to buy you a very big stuff teady bear 🧸❤️️ but unfortunatly muja yad aya ka tum gift ghar nai la ka ja sakti😭 tou muja majbori ma idea cancel karna para aur fasila yahi howa ka jab tak ham sath nai ho sakta tab tak ma ayse chezan nai sakta as tum bohot tension la jjati ho cuto❤️️. As this year you are 19 and big opportunities are coming your way , So be ready for all ,A wish for you on your birthday, whatever you ask may you receive, whatever you seek may you find, whatever you wish may it be fulfilled on your birthday and always. Happy birthday!. I have shared some of my close to heart❤️️ photos and memory . hope you will like it remeber it all the time , eagerly waiting for you on the other side.      (     Ps I am really missing you right now I wish i could be there to eat that cake from your face😙😋) ",
  };

  const passgift = {
    url: "6POZlJAZsok",
    picture: [cutoSurprise],
    Text: "If you are seeing this note , that means ka mari jan have decoded the msg i send thru her from 100's of km , that means ka mari jano is Genius \n Now you might think ka Maazy na muja bataya ku nahi tou agar ma tumha bata data tou ya surprise kasa rehta , so Really happy to ka you have gotten letter without any problem , now here comes the , What are the Chocolates for <3 . well 1 is a small treat , Bari wali wapis a kar doun gan , for my new job , i really tried hard ka muja mari jan ka Pasndida chocolate cake mil jaye swiss roll wala but ma na kamyab raha , so here is a small treat for you from your Maaaazy , second chocolate is to tell you <3 ka I miss you <3 , Just that <3 nothing else <3  , I know baby its hard , but Please bear this Pain and Burden for some more time , inshaAllah Bohot jald ham dono sath hon gan and then we will remember our old time like these with smiles and laughter on our face hehhe <3 any ways make for time being <3 You have to brave and You have been really strong and brave till now , so keep it up , I am really Proud of you for that <3 My baby Girl <3 anyways bohot lambi gap ho gaye han , hopefully you enjoyed the song as well <3 , you can throw away the paper , its not a big deal tou uski tension lana ki zaroorat nai han <3 , anyways <3 I love you mari Payari Madam Misni Ultro Pro Max Zaino <3",
  };
  if (cond === "misni03") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
          <div className="text-center lg:w-2/3 w-auto">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
              Dear Misni Zaino
            </h1>
            <div className="invisible">
              <YoutubeEmbed embedId={zainab.url} autoplay="1" />
            </div>
            <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
              {" "}
              {zainab.text}
            </h1>
          </div>

          <img src={zainab.picture} alt="zaino" className="m-13" />
        </div>
      </section>
    );
  } else if (cond === "beenam-29") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
          <div className="text-center lg:w-2/3 w-auto">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange ali">
              Dear Munneb Kun
            </h1>
            <div className="invisible">
              <YoutubeEmbed embedId={muneeb.url} autoplay="1" />
            </div>
            <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
              {" "}
              {muneeb.text}
            </h1>
          </div>

          <img src={muneeb.picture} alt="zaino" className="m-13 w-56 m-6" />
        </div>
      </section>
    );
  } else if (cond === "muhammad-papi") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
          <div className="text-center lg:w-2/3 w-auto">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
              Dear Muhammad Papi
            </h1>
            <div className="invisible">
              <YoutubeEmbed embedId={Muhammad.url} autoplay="1" />
            </div>
            <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
              {" "}
              {Muhammad.text}
            </h1>
          </div>

          <img src={Muhammad.picture} alt="zaino" className="m-13 w-72 m-8" />
        </div>
      </section>
    );
  } else if (cond === "HBD22") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
          <div className="text-center lg:w-2/3 w-auto">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
              Dear CUTO aka Maaaaazzzy Ki Jan❤️❤️❤️
            </h1>
            <div className="invisible">
              <YoutubeEmbed embedId={HBD22.url} autoplay="1" />
            </div>
            <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
              {" "}
              {HBD22.text}
            </h1>
          </div>
          {HBD22.picture.map((data, index) => {
            return <img src={data} alt="zaino" className="m-13 w-100 m-8" />;
          })}
        </div>
      </section>
    );
  } else if (cond === "SecMsg23") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <SecretMsging
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "OLDMSG") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <OldMsg
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "RestoreMsg") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <RestorePage
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "FavMsg") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <FavMsg
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "ZainoLive") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <ZainoLive
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "MuaazLive") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <MuaazLive
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (cond === "DeleteChat") {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <DeleteChat
          msg={[{ message: "hello this is a secret message", title: "Test 1" }]}
        />
      </section>
    );
  } else if (
    cond.toLowerCase() === "passgift" ||
    cond.toLowerCase() === "gift"
  ) {
    return (
      <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
        <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
          <div className="text-center lg:w-2/3 w-auto">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
              {"Dear Misni Ultra Pro Max Zaino <3"}
            </h1>
            <div className="invisible">
              <YoutubeEmbed embedId={passgift.url} autoplay="1" />
            </div>
            <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
              {" "}
              {passgift.Text}
            </h1>
          </div>

          <img src={passgift.picture} alt="zaino" className="m-13" />
        </div>
      </section>
    );
  }

  return (
    <section className="text-cusWhite font-poppins bg-cusDarkBlack h-screen">
      <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
        <div className="text-center lg:w-2/3 w-auto">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-gray-900 ali">
            Please Turn On Your Location{" "}
          </h1>
        </div>
      </div>
    </section>
  );
}

export default LocationPage;
